module.exports = __webpack_public_path__ + "static/media/cap.bb9daf6f.png";